"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseDeletePointPeage = UseDeletePointPeage;
const react_1 = require("react");
const yup_1 = require("@hookform/resolvers/yup");
const react_2 = require("react");
const react_hook_form_1 = require("react-hook-form");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const yup = __importStar(require("yup"));
const theme_1 = require("../../../../utils/theme");
const Utils_1 = require("../../../../utils/Utils");
const hook_1 = require("../../../../redux/hook");
const point_peage_api_1 = require("../../../../utils/api/point-peage/point-peage.api");
const UseCrudPointPeage = (handleClose, pointPeage) => {
    const validationSchema = yup.object().shape({
        name: yup.string().required("Le nom est requis.").label("Nom"),
        address: yup.string().nullable().label("L'addresse"),
        lat: yup
            .string()
            .required("La latitude est requise.")
            .label("La latitude"),
        long: yup
            .string()
            .required("La longitude est requise.")
            .label("La longitude"),
        is_full_track: yup.boolean().required("Ce champs est requise."),
    });
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const { register, handleSubmit, formState: { errors }, setValue, clearErrors, reset, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
        defaultValues: {
            is_full_track: false,
        },
    });
    const [type, setType] = (0, react_1.useState)(null);
    const [address, setAddress] = (0, react_1.useState)("");
    const [addOrUpdatePointPeage, { isLoading, isSuccess, error, isError }] = (0, point_peage_api_1.useAddOrUpdatePointPeageMutation)();
    const onChangeAddress = (val) => {
        setAddress(val === null || val === void 0 ? void 0 : val.rue);
        setValue("address", val === null || val === void 0 ? void 0 : val.rue);
        setValue("lat", val === null || val === void 0 ? void 0 : val.latitude);
        setValue("long", val === null || val === void 0 ? void 0 : val.longitude);
    };
    const typeOptions = [
        {
            label: "Oui",
            value: true,
        },
        {
            label: "Non",
            value: false,
        },
    ];
    const handleTypeChange = (type) => {
        setType(type);
        setValue("is_full_track", type === null || type === void 0 ? void 0 : type.value);
    };
    (0, react_2.useEffect)(() => {
        var _a, _b;
        if (isSuccess) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `Point de péage ${pointPeage ? "modifié" : "ajouté"} avec succès!`,
                iconColor: theme_1.Color.success,
                showConfirmButton: false,
                timer: 1200,
            }).then(() => {
                if (!pointPeage) {
                    reset();
                }
                handleClose();
            });
        }
        const err = error;
        if (isError) {
            sweetalert2_1.default.fire({
                icon: "error",
                title: ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message)
                    ? (_b = err === null || err === void 0 ? void 0 : err.data) === null || _b === void 0 ? void 0 : _b.message
                    : `Erreur de statut ${err === null || err === void 0 ? void 0 : err.status}`,
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }, [isLoading]);
    (0, react_2.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    const onSubmit = (0, react_1.useCallback)((data) => {
        addOrUpdatePointPeage({ id: pointPeage === null || pointPeage === void 0 ? void 0 : pointPeage.id, data });
    }, [pointPeage === null || pointPeage === void 0 ? void 0 : pointPeage.id, addOrUpdatePointPeage]);
    (0, react_2.useEffect)(() => {
        if (pointPeage === null || pointPeage === void 0 ? void 0 : pointPeage.id) {
            let fields = ["name", "lat", "long"];
            for (let field of fields) {
                register(field);
                setValue(field, pointPeage[field]);
            }
            const isFullTrack = (pointPeage === null || pointPeage === void 0 ? void 0 : pointPeage.is_full_track) === 1 ||
                (pointPeage === null || pointPeage === void 0 ? void 0 : pointPeage.is_full_track) === true;
            setType(isFullTrack);
            setValue("is_full_track", isFullTrack);
        }
    }, [pointPeage]);
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        setValue,
        isLoading,
        reset,
        address,
        onChangeAddress,
        type,
        setType,
        handleTypeChange,
        typeOptions,
    };
};
exports.default = UseCrudPointPeage;
function UseDeletePointPeage(id) {
    const [deleteData] = (0, point_peage_api_1.useDeletePointPeageMutation)();
    const onDelete = () => __awaiter(this, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir supprimer ce point de péage ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return deleteData(id);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            if (result === null || result === void 0 ? void 0 : result.value) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: `Point de péage supprimée avec succès!`,
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        });
    });
    return onDelete;
}
